export default __webpack_public_path__ + "static/media/india_powerline_transmission.f8658cc3.png";